export enum OrderingDirection {
  Ascending,
  Descending,
}
